import React, { useState } from "react";
import AdminPage from "../AdminPage/AdminPage"; // Complaints List Component
import Analysis from "../AdminAnalysis/AdminAnalysis"; // Analysis Component
import ManageAssistants from "../ManageAssistants/ManageAssistants";
import LeaveManagement from "./LeaveManagement";
import { useAuth } from "../../Context/AuthContext";

function AdminDashboard() {
  const { isAssistant } = useAuth();
  const [activeTab, setActiveTab] = useState("complaints"); // Default: Complaints List

  return (
    <div className="p-5">
      {/* Tabs Navigation */}
      <div className="flex space-x-4 mb-4">
        <button
          className={`px-4 py-2 rounded ${activeTab === "complaints" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
          onClick={() => setActiveTab("complaints")}
        >
          Complaints List
        </button>
        <button
          className={`px-4 py-2 rounded ${activeTab === "analysis" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
          onClick={() => setActiveTab("analysis")}
        >
          Analysis
        </button>
        <button
          className={`px-4 py-2 rounded ${activeTab === "assistants" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
          onClick={() => setActiveTab("assistants")}
        >
          Assistants
        </button>
        {!isAssistant && (
          <button
            className={`px-4 py-2 rounded ${activeTab === "leave" ? "bg-blue-500 text-white" : "bg-gray-200"
              }`}
            onClick={() => setActiveTab("leave")}
          >
            Leave
          </button>
        )}
      </div>

      {/* Render Components Based on Selected Tab */}
      <div className="bg-white p-4 shadow rounded">
        {activeTab === "complaints" && <AdminPage />}
        {activeTab === "analysis" && <Analysis />}
        {activeTab === "assistants" && <ManageAssistants onBack={() => setActiveTab("complaints")} />}
        {activeTab === "leave" && (
          <LeaveManagement
            show
            onHide={() => setActiveTab("complaints")}
          />
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
